import type { ComponentProps } from 'node_modules/@types/react';
import { modalRenderer } from '~/modal/modalRendererRegistry';
import { AddNewChartModalContainer } from './addNewChartModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChartsCreate: ComponentProps<typeof AddNewChartModalContainer>;
  }
}
modalRenderer.register('ChartsCreate', AddNewChartModalContainer);
